import React from 'react';
import { Loader, Icon, Table, Button, Header, Label } from 'semantic-ui-react';
import moment from 'moment';
import { alertMessage } from '../../../helper/alert-message';
import { getIdsAndTime, getDuration } from '../helper/helper';
import reportsEnv from '../reportsEnv';
import { reportView } from '../helper/dataService';
import SelectAssetInReport from '../SelectAssetInReport';
import * as ExcelJS from 'exceljs/dist/exceljs.js';

const { durationLimit, assetLimit } = reportsEnv.temperatureViolation;

class TemperatureViolation extends React.Component {
  state = {
    selectedAssets: [],
    startTime: moment().startOf('day'),
    endTime: moment().endOf('day'),
    data: [],
    graphList: [],
    active: false,
    pdfDisableBtn: false,
    excelDisableBtn: false,
  };

  componentDidMount() {
    const {
      selectedAssets = [],
      startTime,
      endTime,
    } = JSON.parse(window.localStorage.getItem('reports_state'));

    this.setState({
      selectedAssets,
      startTime: moment(startTime),
      endTime: moment(endTime),
    });
  }

  getBack = () => {
    this.setState({
      data: [],
    });
  };

  downloadReport = () => {
    this.setState({
      active: true,
      pdfDisableBtn: false,
      excelDisableBtn: false,
    });

    const { ids, startTime, endTime } = getIdsAndTime(this.state);
    reportView(reportsEnv.temperatureViolation, {
      asset_ids: ids,
      from: startTime,
      to: endTime,
    })
      .then((response) => {
        this.setState({
          data: response.data,
          active: false,
        });
      })
      .catch((error) => {
        this.setState({ active: false });
        alertMessage(`Sorry! Something went wrong`);
      });
  };

  handleDownloadExcel = () => {
    const { ids, startTime, endTime } = getIdsAndTime(this.state);

    reportView(reportsEnv.temperatureViolation, {
      asset_ids: ids,
      from: startTime,
      to: endTime,
    })
      .then((response) => {
        if (response.data && response.data.length) {
          const workbook = new ExcelJS.Workbook();
          workbook.creator = 'Finder GPS Tracking';
          workbook.created = new Date();

          workbook.addWorksheet('Temperature Violation Report');

          const worksheet = workbook.getWorksheet(
            'Temperature Violation Report',
          );

          worksheet.addRow(['Finder GPS Tracking']);
          worksheet.addRow(['Temperature Violation Report']);
          worksheet.addRow([
            `Generated on ${moment().format('MMMM Do, YYYY, hh:mm:ss A')}`,
          ]);

          worksheet.columns = [
            { width: 40 },
            { width: 30 },
            { width: 15 },
            { width: 30 },
          ];

          response.data.forEach((item) => {
            worksheet.addRow('');
            worksheet.addRow([`Asset Name: ${item.asset_detail.name}`]);
            worksheet.addRow([
              `Start time: ${moment(startTime).format(
                'dddd, MMMM Do, YYYY, hh:mm:ss A',
              )}`,
            ]);
            worksheet.addRow([
              `End time: ${moment(endTime).format(
                'dddd, MMMM Do, YYYY, hh:mm:ss A',
              )}`,
            ]);

            worksheet.addRow('');
            const headerRow = worksheet.addRow([
              'Time',
              'Sensor Name',
              'Temperature',
            ]);

            // Style the header row
            headerRow.eachCell((cell) => {
              cell.font = {
                bold: true,
                color: { argb: 'FF000000' }, // White
              };
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'CCCCCC' }, // Black
              };
              cell.alignment = { vertical: 'middle', horizontal: 'center' };
              cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
              };
            });
            item.data.forEach((last) => {
              worksheet.addRow([
                moment(last.time.$date).format(
                  'dddd, MMMM Do, YYYY, hh:mm:ss A',
                ),
                last.sensor_name,
                last.temperature,
              ]);
            });
          });

          workbook.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], {
              type: 'application/octet-binary',
            });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Temperature_Violation_${moment().format(
              'MMMM Do, YYYY, hh:mm:ss A',
            )}.xlsx`;
            a.click();
            a.remove();
          });
        }
      })
      .catch((error) => {
        this.setState({ active: false });
        alertMessage(`Sorry! Something went wrong`);
      });
  };

  render() {
    const {
      selectedAssets,
      endTime,
      startTime,
      data,
      active,
      pdfDisableBtn,
      excelDisableBtn,
    } = this.state;

    const duration = getDuration(endTime, startTime);
    const assetsQuantity = selectedAssets.length;

    const isDurationLimitCross = duration > durationLimit;
    const isAssetLimitCross = assetsQuantity > assetLimit;

    if (isDurationLimitCross) {
      alertMessage(
        `You can't select this report more than ${durationLimit} days.`,
      );
    } else if (isAssetLimitCross) {
      alertMessage(
        `You can't select this report more than ${assetLimit} assets.`,
      );
    }

    const title = `Temperature Violation [${durationLimit} days][${assetLimit} asset]`;
    const isValidDuration =
      duration > 0 && endTime.isSameOrAfter(startTime) && !isDurationLimitCross;
    const isValidAsset = assetsQuantity > 0 && !isAssetLimitCross;

    return (
      <>
        {!active && data.length <= 0 && (
          <div className=' center-report'>
            <Header as='h2'>{title}</Header>

            <div style={{ margin: '20px 0' }}>
              <Label.Group size='large'>
                <Label>
                  <Icon name='car' />
                  {assetsQuantity} assets
                </Label>
                <Label>
                  <Icon name='calendar' />
                  {duration} days
                </Label>
                <Label>
                  <Icon name='play' />
                  {moment(startTime).format('dddd, MMMM Do, YYYY, hh:mm:ss A')}
                </Label>
                <Label>
                  <Icon name='stop' />
                  {moment(endTime).format('dddd, MMMM Do, YYYY, hh:mm:ss A')}
                </Label>
              </Label.Group>
            </div>

            {isValidDuration && isValidAsset && (
              <Button.Group>
                <Button
                  color='black'
                  style={{ width: '200px', fontSize: '16px' }}
                  onClick={this.downloadReport}
                  icon='eye'
                  content='VIEW HERE'
                  disabled={pdfDisableBtn || excelDisableBtn}
                />

                <Button
                  color='teal'
                  style={{ width: '200px', fontSize: '16px' }}
                  icon='file excel outline'
                  content='Download Excel'
                  onClick={this.handleDownloadExcel}
                  disabled={excelDisableBtn || pdfDisableBtn}
                  loading={excelDisableBtn}
                />
              </Button.Group>
            )}
          </div>
        )}
        {!active && data.length > 0 ? (
          <div style={{ margin: '2%' }}>
            <div className='left-right'>
              <div>
                <Header as='h2'>Temperature Violation</Header>
                <p>
                  Generated on: {moment().format('MMMM Do, YYYY, hh:mm:ss A')}
                </p>
              </div>
              <Button primary onClick={this.getBack}>
                Back
              </Button>
            </div>
            <br />

            {data.map((item, i) => (
              <div key={i} id={item.asset_detail.name}>
                <div className='ui stackable grid'>
                  <div className='eight wide column' style={{ paddingLeft: 0 }}>
                    <div className='ui card fluid'>
                      <div className='content'>
                        <div className='header'>{item.asset_detail.name}</div>

                        <div className='description'>
                          <div>
                            <p>
                              <i className='arrow right icon' /> From:
                              {moment(startTime).format(
                                'dddd, MMMM Do, YYYY, hh:mm:ss A',
                              )}
                            </p>
                            <p>
                              <i className='arrow right icon' /> Till:{' '}
                              {moment(endTime).format(
                                'dddd, MMMM Do, YYYY, hh:mm:ss A',
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='eight wide column'
                    style={{ paddingRight: 0 }}
                  >
                    <div className='ui card fluid'>
                      <div className='content'>
                        <h2 className='ui center aligned icon header'>
                          <i className='circular car icon' />
                          <h3>Total Violations: {item.data.length}</h3>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>

                <Table celled>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Time</Table.HeaderCell>
                      <Table.HeaderCell>Sensor Name</Table.HeaderCell>
                      <Table.HeaderCell>Temperature (°C)</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body>
                    {item.data.map((last, idx) => (
                      <Table.Row key={idx}>
                        <Table.Cell>
                          {last.time
                            ? moment(last.time.$date).format(
                                'dddd, MMMM Do, YYYY, hh:mm:ss A',
                              )
                            : ''}
                        </Table.Cell>
                        <Table.Cell>{last.sensor_name}</Table.Cell>
                        <Table.Cell>{last.temperature}</Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
                <br />
              </div>
            ))}

            {data.length > 1 ? <SelectAssetInReport assetList={data} /> : null}
          </div>
        ) : (
          <Loader active={active} inline='centered'>
            {' '}
            Generating...
          </Loader>
        )}
      </>
    );
  }
}

export default TemperatureViolation;
